export default {
	available: "Product is available",
	unavailable: "Product is unavailable",
	code: "Product code",
	size: "Size",
	color: "Color",
	buy: "Buy now",
	addToCart: "Add to Cart",
	addedIntoCart: "item(s) added to cart",
	viewCart: "View Cart & Checkout",
	continueShopping: "Continue Shopping",
    askSeller: "Ask seller",
    infoMsg: {
	    productDeliveresAndSells: "The product delivers and sells",
        trgujShowsOffer: "Platform Trguj.me only shows the offer.",
		delivery: 'Estimated delivery date:'
    }
};
